<template>
    <div class="countdown background-circle">
        <h3 v-if="title">{{ title }}</h3>
        <div class="panel">
            <div class="block" v-if="onlyDays > 99">
                <span class="digit">{{ months | digits }}</span>
                <span class="text">{{ trans.months }}</span>
            </div>

            <div class="block" v-if="onlyDays <= 99">
                <span class="digit">{{ onlyDays | digits }}</span>
                <span class="text">{{ trans.days }}</span>
            </div>

            <div class="block" v-if="onlyDays > 99">
                <span class="digit">{{ days | digits }}</span>
                <span class="text">{{ trans.days }}</span>
            </div>

            <div class="block">
                <span class="digit">{{ hours | digits }}</span>
                <span class="text">{{ trans.hours }}</span>
            </div>

            <div class="block" v-if="onlyDays <= 99">
                <span class="digit">{{ minutes | digits }}</span>
                <span class="text">{{ trans.minutes }}</span>
            </div>
        </div>
        <h3 v-if="subtitle">{{ subtitle }}</h3>
    </div>
</template>

<style lang="scss" scoped>
    .countdown {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 32px;
        background-color: #E90B7E;
        background: linear-gradient(90deg, #E90B7E 0%, #FF5A5A 100%);
        color: #FFFFFF;

        @media (min-width: 583px) {
            border-radius: 20px;
        }
    }

    .panel {
        display: flex;
        justify-content: center;
        margin: 24px 0;

        .block {
            margin: 0 8px;
            text-align: center;

            .digit {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 80px;
                height: 80px;
                font-size: 55px;
                font-weight: bold;
                border: 2px solid rgba(#FFFFFF, .45);
                border-radius: 10px;
                line-height: 1;
            }

            .text {
                text-transform: uppercase;
                color: rgba(#FFFFFF, .45);
            }

            @media (min-width: 440px) {
                margin: 0 16px;

                .digit {
                    width: 100px;
                    height: 100px;
                    font-size: 66px;
                }
            }
        }
    }

    h3 {
        margin: 0;
        font-size: 24px;
        line-height: 1;

        @media (min-width: 440px) {
            font-size: 30px;
        }
    }
</style>

<script>
    export default {
        props: {
            date: {
                type: String,
                required: true,
            },
            trans: {
                type: Object,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            subtitle: String,
        },

        mounted() {
            window.setInterval(() => {
                this.now = Math.trunc((new Date()).getTime() / 1000);
            }, 1000);
        },

        data() {
            return {
                now: Math.trunc((new Date()).getTime() / 1000),
                end: Math.trunc(Date.parse(this.date) / 1000)
            }
        },

        computed: {
            seconds() {
                return (this.end - this.now) % 60;
            },

            minutes() {
                return Math.trunc((this.end - this.now) / 60) % 60;
            },

            hours() {
                return Math.trunc((this.end - this.now) / 60 / 60) % 24;
            },

            days() {
                return Math.trunc((this.end - this.now) / 60 / 60 / 24) % 30;
            },

            onlyDays() {
                return Math.trunc((this.end - this.now) / 60 / 60 / 24);
            },

            months() {
                return Math.trunc((this.end - this.now) / 60 / 60 / 24 / 30);
            }
        }
    }
</script>
